import { render, staticRenderFns } from "./RuleInfoDialog.vue?vue&type=template&id=3ed4a194&scoped=true"
import script from "./RuleInfoDialog.vue?vue&type=script&lang=ts"
export * from "./RuleInfoDialog.vue?vue&type=script&lang=ts"
import style0 from "./RuleInfoDialog.vue?vue&type=style&index=0&id=3ed4a194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed4a194",
  null
  
)

export default component.exports